import { digitsToUSPhone } from '@hc-frontend/core-types-transformers';
import { removeEmptyKeys } from '@hc-frontend/core-utils-object';

import type { ContactInformation } from '../../domain';
import type { userAttributesMapper } from './user-attributes-mapper';

export function contactMapper(
  userAttributesMap: ReturnType<typeof userAttributesMapper>,
): ContactInformation {
  const contact: ContactInformation = {
    firstName: userAttributesMap.firstName,
    lastName: userAttributesMap.lastName,
    phoneNumber: userAttributesMap.phoneNumber
      ? digitsToUSPhone(userAttributesMap.phoneNumber)
      : undefined,
    address: userAttributesMap.address,
    email: userAttributesMap.email,
  };

  return removeEmptyKeys(contact);
}
